<template>
  <div class="container">
    <PublicHeader :totalName="$t('lockming').title" />
    <div class="content">
      <van-list
        class="list-box"
        ref="list"
        v-model="loading"
        :finished="finished"
        :loading-text="$t('public').loadingText"
        :finished-text="$t('public').noMoreData"
        @load="getList"
      >
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="line top">
            <span class="name">{{ showTitle(item) }}</span>
            <span class="btn">{{
              item.IsEnd ? $t('lockming').finished : $t('lockming').doing
            }}</span>
          </div>
          <div class="line">
            <div>{{ $t('lockming').sl }}：{{ item.BuyNum }}</div>
            <div class="profit-click" @click="showProfitDetail(item)">{{ $t('lockming').shouyilv }}：{{ item.Rate }}%</div>
            <div>
              {{ $t('lockming').scqx }}：{{ item.DayNum
              }}{{ $t('lockming').day }}
            </div>
          </div>
          <div class="line date">
            <div>
              <div>{{ $t('lockming').ks }}：</div>
              <div>{{ item.StartTime | getLocalTime }}</div>
            </div>
            <div>
              <div>{{ $t('lockming').js }}：</div>
              <div>{{ item.EndTime | getLocalTime }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="overlay" v-if="showProfit">
      <div class="box">
        <div class="title">
          {{ $t('lockming').profitDetail || '收益详情' }}
        </div>
        <div v-if="profitLoading" class="loading">
          {{ $t('public').loadingText || '加载中...' }}
        </div>
        <div v-else-if="profitData">
          <div class="line" v-for="(value, key) in formatProfitData(profitData)" :key="key">
            <span>{{ formatProfitKey(key) }}</span>
            <span>{{ formatProfitValue(value, key) }}</span>
          </div>
        </div>
        <div v-else class="loading">
          {{ $t('public').noData || '暂无数据' }}
        </div>
        <div class="btns">
          <div class="btn" @click="showProfit = false">{{ $t('public').confirm || '确定' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeaderNew'
import productApi from '@/api/product'
import { mapGetters } from 'vuex'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      list: [],
      form: {
        page: 1,
        size: 10
      },
      loading: false,
      finished: false,
      showProfit: false,
      profitData: null,
      profitLoading: false,
      currentItem: null
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  methods: {
    showTitle(item) {
      if (this.lang === 'zh') {
        return item.ChineseName
      } else {
        return item.EnglishName
      }
    },
    async getList() {
      const res = await productApi.getMiningRecords(this.form)
      let data = res.Data
      let length = data.length
      if (length != 0) {
        this.list.push.apply(this.list, data)
        this.form.page++
      }
      if (length !== this.form.size) {
        this.finished = true
      }
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = false
    },
    async showProfitDetail(item) {
      this.currentItem = item
      this.showProfit = true
      this.profitLoading = true
      this.profitData = null
      try {
        // 使用 orderId 作为参数
        const params = { orderId: item.Id || item.OrderId || item.orderId }
        const res = await productApi.getMiningProfit(params)
        this.profitData = res.Data || res
      } catch (error) {
        this.$toast(this.$t('public').error || '获取收益信息失败')
        console.error('获取收益信息失败:', error)
      } finally {
        this.profitLoading = false
      }
    },
    formatProfitKey(key) {
      // 格式化键名，根据接口返回的字段做国际化处理
      const keyMap = {
        'AmountSum': this.$t('lockming').amountSum || '总投资',
        //'AreadyProfit': this.$t('lockming').areadyProfit || '总收益',
        'OrderSum': this.$t('lockming').orderSum || '当前进行中订单数量',
        'TodayProfig': this.$t('lockming').todayProfig || '当日预计收益',
        'DayNum': this.$t('lockming').dayNum || '天数',
        'Rate': this.$t('lockming').rate || '利率',
        'Profit': this.$t('lockming').profit || '收益'
      }
      return keyMap[key] || key
    },
    formatProfitValue(value, key) {
      // 格式化值，金额类字段后面加 USDT 单位
      //const amountKeys = ['AmountSum', 'AreadyProfit', 'TodayProfig', 'Profit'] // 需要加单位的字段
      const amountKeys = ['AmountSum', 'TodayProfig', 'Profit'] // 需要加单位的字段
      const needUnit = amountKeys.includes(key)
      
      // 处理 null 或 undefined
      if (value === null || value === undefined) {
        return '-'
      }
      
      // Rate 字段显示为百分比
      if (key === 'Rate') {
        if (typeof value === 'number') {
          return `${value}%`
        }
        if (typeof value === 'string') {
          return `${value}%`
        }
        return value
      }
      
      // DayNum 字段显示为整数（不显示小数）
      if (key === 'DayNum') {
        if (typeof value === 'number') {
          return Math.floor(value).toString()
        }
        if (typeof value === 'string') {
          const numValue = parseFloat(value)
          if (!isNaN(numValue)) {
            return Math.floor(numValue).toString()
          }
          return value
        }
        return value
      }
      
      // 其他字段：接口返回什么就显示什么，只在需要时添加单位
      if (needUnit) {
        return `${value} USDT`
      }
      return value
    },
    formatProfitData(data) {
      // 格式化收益数据，处理不同的数据结构
      if (!data) return {}
      let result = {}
      if (Array.isArray(data)) {
        // 如果是数组，转换为对象
        data.forEach((item, index) => {
          if (typeof item === 'object') {
            Object.assign(result, item)
          } else {
            result[`item${index}`] = item
          }
        })
      } else {
        result = data
      }
      // 过滤掉收益字段
      const {AreadyProfit, ...filteredData } = result
      return filteredData
    }
    // formatProfitData(data) {
    //   // 格式化收益数据，处理不同的数据结构
    //   if (!data) return {}
    //   if (Array.isArray(data)) {
    //     // 如果是数组，转换为对象
    //     const result = {}
    //     data.forEach((item, index) => {
    //       if (typeof item === 'object') {
    //         Object.assign(result, item)
    //       } else {
    //         result[`item${index}`] = item
    //       }
    //     })
    //     return result
    //   }
    //   return data
    // }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding-top: 44px;
  .content {
    margin: 10px;
    border-radius: 4px;
    .list-box {
      height: calc(100vh - 64px);
      overflow: scroll;
    }
    .item {
      background: #17181e;
      padding: 10px;
      border-bottom: 1px solid #1f253c;
      .line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
      }
      .top {
        margin-top: 5px;
        font-weight: bold;
        display: flex;
        align-items: center;
        .btn {
          width: 60px;
          height: 25px;
          font-size: 12px;
          background: #00abff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
        }
      }
      .name {
        font-size: 16px;
      }
      .date {
        color: #999;
        line-height: 1.5;
      }
      .profit-click {
        cursor: pointer;
        color: #00abff;
        text-decoration: underline;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;

    .box {
      width: 90%;
      max-width: 500px;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;

      .title {
        font-size: 18px;
        color: #000;
        text-align: center;
        line-height: 50px;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
      }

      .loading {
        padding: 40px 20px;
        text-align: center;
        color: #999;
      }

      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 20px;
        font-size: 14px;
        border-bottom: 1px solid #f5f5f5;
        color: #333;

        span:nth-of-type(1) {
          color: #999;
        }

        span:nth-of-type(2) {
          font-weight: bold;
          color: #000;
        }
      }

      .btns {
        padding: 20px;
        display: flex;
        justify-content: center;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 45px;
          background-color: #f2ba18;
          color: #fff;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
